"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeValueItem = void 0;
var attribute_value_item_component_1 = require("./attribute-value-item.component");
Object.defineProperty(exports, "AttributeValueItem", { enumerable: true, get: function () { return attribute_value_item_component_1.AttributeValueItem; } });
